import React from 'react';
import { FeedsDataItem } from '../feeds_list_types';

interface ParsingTotalsPanelProps {
    feedItem: FeedsDataItem;
}

const ParsingTotalsPanel = ({ feedItem }: ParsingTotalsPanelProps): JSX.Element => {
    return (
        <section className="parsing-totals-section panel-spacing">
            <h3>Parsing Totals</h3>
            <div className="totals-row">
                <div className="total-item">
                    <label>Received:</label>
                    <span>{feedItem.RecordsReceived?.toLocaleString() || '0'}</span>
                </div>
                <div className="total-item">
                    <label>Processed:</label>
                    <span>{feedItem.RecordsProcessed?.toLocaleString() || '0'}</span>
                </div>
                <div className="total-item">
                    <label>Duplicate:</label>
                    <span>{feedItem.RecordsDuplicate?.toLocaleString() || '0'}</span>
                </div>
                <div className="total-item">
                    <label>Rejected:</label>
                    <span>{feedItem.RecordsRejected?.toLocaleString() || '0'}</span>
                </div>
                <div className="total-item">
                    <label>Errors:</label>
                    <span>{feedItem.RecordsError?.toLocaleString() || '0'}</span>
                </div>
            </div>
        </section>
    );
};

export default React.memo(ParsingTotalsPanel);
